<div tooltip data-popover="{{tooltip}}" [popover]="tooltip" triggers="hover" containerClass="custom-popover">
  <ng-content></ng-content>
</div>
